import React, { useRef } from 'react';

const BirthHistoryForm: React.FC = () => {
  const formRef = useRef<HTMLFormElement>(null);
  const clear = () => formRef.current?.reset();

  const earlyLateQs = [
    'Was the labor induced?',
    'Was the labor helped by medication?',
    'Was the baby born early (less than 38 weeks)?',
    'Was the baby born late (after 42 weeks)?',
  ];

  const hospitalQs = [
    'Antibiotic Treatment',
    'Blue Spells',
    'Convulsions',
    'Jaundice',
    'Skin Rash',
    'Did the baby remain in hospital longer than the mother?',
  ];

  return (
    <form ref={formRef} className="family-form">
      <div className="form-grid">
        <div className="field">
          <label>Place of birth</label>
          <input type="text" />
        </div>
        <div className="field">
          <label>Duration of labor</label>
          <input type="text" />
        </div>
        <div className="field">
          <label>Baby's birth weight</label>
          <input type="text" />
        </div>
        <div className="field">
          <label>Apgar Score (if known)</label>
          <input type="text" />
        </div>
        <div className="field col-span-2">
          <label>What was the method of delivery:</label>
          <select>
            <option>Click here to choose</option>
            <option>Vaginal</option>
            <option>Cesarean</option>
            <option>Forceps/Vacuum</option>
            <option>Other</option>
          </select>
        </div>
      </div>

      <div className="yesno-list one" style={{marginTop: 8}}>
        {earlyLateQs.map((q, i) => (
          <div key={q} className="yesno-item">
            <span className="lbl">{q}</span>
            <label><input type="radio" name={`birth-earlylate-${i}`} /> Yes</label>
            <label><input type="radio" name={`birth-earlylate-${i}`} /> No</label>
          </div>
        ))}
      </div>

      <div className="section-title">During the hospital stay, did the baby have any of the following:</div>
      <div className="yesno-list one">
        {hospitalQs.map((q, i) => (
          <div key={q} className="yesno-item">
            <span className="lbl">{i + 1}. {q}</span>
            <label><input type="radio" name={`birth-hosp-${i}`} /> Yes</label>
            <label><input type="radio" name={`birth-hosp-${i}`} /> No</label>
          </div>
        ))}
      </div>

      <div className="yesno-list one" style={{marginTop: 8}}>
        <div className="yesno-item">
          <span className="lbl">How was / is the baby fed?</span>
          <label><input type="radio" name="birth-fed" /> Bottle</label>
        </div>
        <div className="yesno-item">
          <span className="lbl"></span>
          <label><input type="radio" name="birth-fed" /> Breast</label>
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-clear" onClick={clear}>Clear</button>
      </div>
    </form>
  );
};

export default BirthHistoryForm;


